import { render, staticRenderFns } from "./FacilityTypeList.vue?vue&type=template&id=17352d78"
import script from "./FacilityTypeList.vue?vue&type=script&lang=js"
export * from "./FacilityTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports